import script from "./SLATab.vue?vue&type=script&setup=true&lang=ts"
export * from "./SLATab.vue?vue&type=script&setup=true&lang=ts"

import "./SLATab.vue?vue&type=style&index=0&id=a34c1838&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a34c1838"]])

export default __exports__